import { toggleModal } from '~/components/modal';

const selectors = {
  mobileNav: 'mobile-nav',
  searchToggle: '[data-search-toggle]',
  searchInput: '[data-search-input]',
  up: 'is-scrolled-up',
  down: 'is-scrolled-down',
  isSubNavActive: 'is-sub-active',
  subNavWrapper: '[data-sub-nav-wrapper]',
  subNav: '[data-sub-nav]',
  observer: '[data-header-observer]',
};

let lastScrollY = window.pageYOffset;
let subIsHovered = false;
const searchToggles = document.querySelectorAll(selectors.searchToggle);
const searchInput = document.querySelector(selectors.searchInput);
const mobileNav = document.getElementById(selectors.mobileNav);

window.addEventListener('scroll', () => {
  const scrollY = window.pageYOffset;

  if (document.body.classList.contains('is-loading')) return;

  if (lastScrollY > 15) {
    if (Math.abs(scrollY - lastScrollY) > 15) {
      document.body.classList.toggle(selectors.up, scrollY < lastScrollY);
      document.body.classList.toggle(selectors.down, scrollY > lastScrollY);
    }
  } else {
    document.body.classList.remove(selectors.up);
    document.body.classList.remove(selectors.down);
  }

  lastScrollY = scrollY > 0 ? scrollY : 0;
}, { passive: true });

searchToggles && searchToggles.forEach(searchToggle => {
  searchToggle.addEventListener('click', () => {
    document.body.classList.toggle('is-search-active');
    mobileNav.classList.contains('is-shown') && toggleModal(mobileNav.id, false, true);
    searchInput && searchInput.focus();
  });
});

window.addEventListener('modal:open', e => {
  const isNav = e.target.id === selectors.mobileNav;
  isNav && document.body.classList.remove('is-search-active');
});

// const toggleSubNav = (active) => {
//   setTimeout(() => {
//     document.body.classList.toggle(selectors.isSubNavActive, active);
//   }, 100);
// };
//
// const onSubNavItemMouseOver = e => {
//   requestAnimationFrame(() => {
//     subIsHovered = true;
//     const height = e.target.querySelector(selectors.subNav).getBoundingClientRect().height;
//     document.documentElement.style.setProperty('--sub-nav-height', `${height}px`);
//     toggleSubNav(true);
//   });
// };
//
// const isHovered = document.querySelector('.has-sub-nav:hover');
// isHovered && onSubNavItemMouseOver({ target: isHovered });
//
// const onSubNavItemMouseLeave = e => {
//   subIsHovered = false;
//   requestAnimationFrame(() => {
//     if (!subIsHovered) {
//       document.documentElement.style.setProperty('--sub-nav-height', `0px`);
//       toggleSubNav(false);
//     }
//   });
// };

// new IntersectionObserver((el) => {
//   if (el[0].isIntersecting) {
//     setTimeout(() => {
//       document.body.classList.remove(selectors.up)
//       document.body.classList.remove(selectors.down)
//     }, 50)
//   }
// }).observe(document.querySelector(selectors.observer))

// document.querySelectorAll(selectors.subNavWrapper).forEach(el => {
//   el.addEventListener('mouseenter', onSubNavItemMouseOver);
//   el.addEventListener('mouseleave', onSubNavItemMouseLeave);
// });
